export default {
  //平台业务
  PAGE_BUSSINESS_FARMER_PHOTO_REVIEW: '58',

  //系统基础
  PERMISSION_USER_INDEX: '5',//用户管理
  // PERMISSION_USER_ADD: '1001',//用户管理-新增
  // PERMISSION_USER_MODIFY: '1002',//用户管理-新增
  // PERMISSION_USER_DROP: '1003',//用户管理-删除
  PERMISSION_PERMISSION_INDEX: '2',//权限管理
  // PERMISSION_DICTTYPE_INDEX: '109',//字典管理
  PERMISSION_SYSTEM_BSSYSCONFIG: '12',//系统配置
  // PERMISSION_USER_CHANNEL: '128',//用户渠道维护
  // PERMISSION_APP_INDEX: '111',//APP版本管理
  PERMISSION_APP_MANAGER_INDEX: '130',//APP管理
  // PERMISSION_BANNER_INDEX: '103',//轮播图管理

  PERMISSION_ROLE_INDEX: '13',//角色管理
  // PERMISSION_FEEDBACK_INDEX: '115',//意见反馈

  // PERMISSION_ORGAN_INDEX: '116',//机构管理


  //模板
  // PERMISSION_SYS_ROLE: '2001',
  // PERMISSION_SYS_USER: '2002',
  PERMISSION_BUSINESS_PHOTOEXAMINE: '67',//照片审核
  PERMISSION_BUSINESS_APPOINTMENTRECOVERY: '74',//可回收预约
  PERMISSION_BUSINESS_FAMILYAPPIONTMENT:'1112',//家宴预约
  // PERMISSION_BUSINESS_APPOINTMENTRECOVERYVILLAGE: '2005',//管辖村级详情
  // PERMISSION_BUSINESS_APPOINTMENTRECOVERYUSERDETAIL: '2006',//可回收预约-管辖用户详情
  PERMISSION_BUSINESS_INSPECTOR:'59',//督察员
  PERMISSION_BUSINESS_COLLECTOR:'2020',//收集员
  PERMISSION_BUSINESS_AUDITOR: '2324',//审核员工作
  PERMISSION_BUSINESS_PAVILIONTOWN:'204',//亭长签到
  PERMISSION_BUSINESS_SECRETINSPECTION:'200',//督查暗访
  PERMISSION_BUSINESS_GARBAGEROOM: '53',//垃圾房管理
  // PERMISSION_BUSINESS_PERISHABLESTATION: '2009',//易腐处理站
  PERMISSION_BUSINESS_RANK: '118',//排名信息
  PERMISSION_BUSINESS_SELFHELPRECOVERY: '3002',//自助回收
  PERMISSION_TRADEMANAGE_TRADEFLOW: '69',//交易流水
  PERMISSION_TRADEMANAGE_ACCOUNTINFO: '37',//账户信息
  PERMISSION_TRADEMANAGE_ACCOUNTFLOW: '68',//账户流水
  PERMISSION_TRADEMANAGE_INTEGRALTOTAL: '190',//用户积分余额汇总
  PERMISSION_TRADEMANAGE_INTEGRALEXCHANGE: '2026',//积分兑换统计
  PERMISSION_BASICDATA_STARSPLANMANAGE: '2024',//评星计划管理
  PERMISSION_TRADEMANAGE_BANKCARDMANAGE: '2035',//银行卡管理
  PERMISSION_BASICDATA_DICTIONARY: '19',//数据字典
  // PERMISSION_BASICDATA_REDBAGCASECONFIG: '260',//红包活动配置
  PERMISSION_BASICDATA_STARTYPEMANAGE: '2039',//评星项管理
  PERMISSION_BASICDATA_SECTORALLOCATION: '3039',//行业配置管理
  PERMISSION_BASICDATA_BONUSPOINTS:'2085',//奖励积分
  PERMISSION_BASICDATA_WORKCONTACT: '2323',//工作人员联系表
  PERMISSION_BUSINESS_GARBAGEBAGMANAGE: '1113',//垃圾袋管理
  // PERMISSION_BUSINESS_GARBAGEBAGCOUNT: '2023',//垃圾袋入库统计
  PERMISSION_BUSINESS_DELIVERY:"1000",//定时定点投放

    PERMISSION_SYSTEM_MERCHANTS: '3038',//商户管理
  PERMISSION_SYSTEM_PROPAGATEIMG: '7',//宣传图
  PERMISSION_SYSTEM_RECOVERYPRICE:'39',//回收价格
  PERMISSION_BASICDATA_PAYMENTSCORECONFIG: '3059',//用户缴费积分配置
  PERMISSION_BASICDATA_GOODSMANAGE: '2025',//商品管理
  PERMISSION_BASICDATA_RECYCLESITE: '36',//回收站点管理
  PERMISSION_BASICDATA_ROTGARBAGECAPACITY: '3056',//易腐垃圾回收设备
  PERMISSION_BASICDATA_ORGANRELATE: '3057',//自查机构管理
  PERMISSION_BASICDATA_PURCHASEACTIVITIES: '260',//活动配置
  PERMISSION_SYSTEM_CHANNELAUTHCODE: '3060',//授权码管理
  PERMISSION_BUSINESS_EQUIPMENTSTATISTICS: '2038',//设备自查统计
  PERMISSION_TRADEMANAGE_COMPENSATE: '500',//商户积分补偿
  PERMISSION_TRADEMANAGE_WITHDRAWAL: '38',//商户提现
  PERMISSION_SYSTEM_ORGAN: '3057',//机构管理
  PERMISSION_BUSINESS_GARBAGETOTAL:'160',//垃圾汇总
  PERMISSION_BUSINESS_PERISHABLESTATION:'2022',//易腐处理站
  PERMISSION_BASICDATA_NEWS: '3159',//新闻管理
  PERMISSION_BASICDATA_QUESTIONMANAGE: '3160',//考题管理
  PAGE_BUSINESS_SUPERVISORPUNCHLCLOCK:'3161',//督导员打卡统计
  PAGE_BUSINESS_INSPECTORPUNCHCLOCK:'3162',//巡查员打卡统计
  PAGE_BUSINESS_PICKUPSTAFFPUNCHCLOCK:'3163',//清运人员打卡统计

}




// WEBPACK FOOTER //
// ./src/constant/PermissionIds.js